<template>
  <k-panel title="Add Competency"
    icon='fa-list-check'
    :showContent="showContent"
    @toggle="showContent = $event"
  >
    <template #body>
      <div class="add-competency-form">
        <div class="add-competency-details">
            <fieldset class="form-programme form-entry">
                <label for="add-competency-category-input">Category</label>
                <k-dropdown id="add-competency-category-input" type="text" placeholder="Category" :options="categoryOptions" v-model="formCategory" :showSearch="false"></k-dropdown>
            </fieldset>
            <fieldset class="form-programme form-entry">
                <label for="add-competency-label-input">Label</label><br>
                <small class="info"><i>K1, K2, S1, B1 etc...</i></small>
                <div class="add-competency-input-container">
                  <span>{{ competencyPrefix }}</span>
                  <input id="add-competency-label-input" type="number" class="form-control" placeholder="1, 2, 3..." v-model="formLabel" min="1" step="1">
                </div>
                <span v-if="labelTaken" class="info form-label-warning">This label is already in use. Please choose another.</span>
              </fieldset>
            <fieldset class="form-programme form-entry">
                <label for="add-competency-description-input">Description</label>
                <textarea id="add-competency-description-input" class="form-control" placeholder="Type description here..." v-model="formDescription"></textarea>
            </fieldset>
        </div>
        <div class="add-competency-actions">
            <button class="btn btn-primary add-competency-button" @click="addCompetency" :disabled="!validForm">
                <i class="fas fa-plus" aria-hidden="true"></i> Add Competency
            </button>
        </div>
      </div>
    </template>
  </k-panel>
</template>

<style scoped>
.add-competency-details {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.add-competency-actions {
  margin-top: 1rem;
}

.form-label-warning {
  color: var(--kate-warning);
}

.add-competency-input-container {
  display: flex;
  align-items: center;
}

.add-competency-input-container span {
  padding: 0 10px;
  height: 38px;
  border: var(--input-border-alt);
  line-height: normal;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background-color: #a8b4c7;
  color: var(--kate-type-dark);
  display: flex;
  font-size: 1.2em;
  align-items: center;
  font-family: hk-grotesk-bold, sans-serif;
}

.add-competency-input-container input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>

<script>

import KPanel from '@base-components/k-panel.vue';
import KDropdown from '@base-components/k-dropdown.vue';

export default {
  components: {
    KPanel,
    KDropdown,
  },

  props: {
    programme: {
      type: Object,
      required: true,
    },
    isBlueprint: {
      type: Boolean,
      default: false,
    },
    competencies: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['update'],
  data() {
    return {
      showContent: false,
      formCategory: 'Knowledge',
      formLabel: '',
      formDescription: '',
      categoryOptions: [
        { id: 'Knowledge', name: 'Knowledge' },
        { id: 'Skill', name: 'Skill' },
        { id: 'Behaviour', name: 'Behaviour' },
      ],
    };
  },

  methods: {
    addCompetency() {
      this.$logger.info(`Adding ${this.entityName} competency`, {
        category: this.formCategory,
        label: this.competencyLabel,
        description: this.formDescription,
      });
      this.$Loading.start();
      this.$http.post(this.apiEndpoint, {
        category: this.formCategory,
        label: this.competencyLabel,
        description: this.formDescription,
      })
        .then(() => {
          this.$logger.info(`Successfully added ${this.entityName} competency`, {
            category: this.formCategory,
            label: this.competencyLabel,
            description: this.formDescription,
          });
          this.$ktoast.success(`${this.entityName} competency added`);
          this.clearFields();
          this.$emit('update');
        })
        .catch(err => {
          this.$logger.error(`Could not add ${this.entityName} competency`, err);
          this.$ktoast.showError(err);
        })
        .then(() => {
          this.$Loading.finish();
        });
    },
    clearFields() {
      this.formLabel = '';
      this.formDescription = '';
      this.formCategory = 'Knowledge';
    },
  },

  computed: {
    competencyPrefix() {
      return this.formCategory ? this.formCategory.charAt(0).toUpperCase() : '';
    },

    competencyLabel() {
      return this.formLabel ? `${this.competencyPrefix}${String(this.formLabel)}` : '';
    },

    labelTaken() {
      if (!this.competencyLabel) return false;
      return this.competencies.some(record => record.label.toLowerCase() === this.competencyLabel.toLowerCase());
    },

    apiEndpoint() {
      return `/api/curriculum/${this.isBlueprint ? 'blueprints/' : ''}programmes/${this.entityId}/competencies`;
    },
    entityId() {
      return Number(this.isBlueprint ? this.$route.params.programmeBlueprintId : this.$route.params.programmeId);
    },
    entityName() {
      return this.isBlueprint ? 'Programme blueprint' : 'Programme';
    },
    validForm() {
      const hasLabel = this.formLabel && String(this.formLabel).trim();
      const hasDescription = this.formDescription && this.formDescription.trim();
      return Boolean(this.formCategory && hasLabel && hasDescription && !this.labelTaken);
    },
  },
};
</script>
